/**
 * Barrel export for {@link LineItemDisplayRowContainer}.
 * @module features/contracts/components/LineItemDisplayRow
 */

export { default } from "./LineItemDisplayRowContainer";
